import { FeatureServiceProviderDefinition } from '@feature-hub/core';
import { FeatureappServiceV1 } from '@volkswagen-onehub/featureapp-service';
import { InteractionLayerSizeV2, LayerManagerV24, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import { UserInteractionServiceV22 } from '@volkswagen-onehub/user-interaction-service';
import { OneformV2LayerContent } from './oneformV2-layer-content';

export const oneformV2ActionFeatureServiceDefinition: FeatureServiceProviderDefinition<any> = {
	id: 'es:oneform-v2-action-feature-service',
	dependencies: {
		featureServices: {
			'user-interaction-service': '^2.2.0',
			'layer-manager': '^2.5.0',
			'featureapp-service': '^1.0.0',
		},
	},

	create: ({ featureServices }) => {
		const userInteractionService = featureServices['user-interaction-service'] as UserInteractionServiceV22;

		const layerManager = featureServices['layer-manager'] as LayerManagerV24;
		const featureAppService = featureServices['featureapp-service'] as FeatureappServiceV1;
		const featureAppOneformV2 = featureAppService.featureAppConfigurations['es-oneformv2-oneform'];

		userInteractionService.register('es-oneform-v2-action--open_layer', {
			action: (params) => {
				layerManager.openInteractionLayer(
					OneformV2LayerContent,
					{
						featureApp: featureAppOneformV2,
						params: params,
						isLayer: true,
					},
					{
						size: InteractionLayerSizeV2.D,
						shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
						userCloseable: true,
					},
				);
			},
		});

		return {
			'1.0.0': () => ({
				featureService: {},
			}),
		};
	},
};
